import { NgModule } from '@angular/core';
import { RegistrationComponent } from './registration.component';
import { RouterModule } from '@angular/router';
//import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CxFormsModule } from '@forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiFormatModule } from '@ui-format';
import { VerificationCodeComponent } from './verification.code.component';
import { VerificationService } from './verification.service';
import { ExtLoginRegistrationInfoComponent } from './ext.login.registration.info.component';

@NgModule({
    imports : [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CxFormsModule,
        UiFormatModule
    ],
    declarations : [
        RegistrationComponent,
        VerificationCodeComponent,
        ExtLoginRegistrationInfoComponent
    ],
    providers : [
        VerificationService
    ]
})
export class RegistrationModule {

}

export {
    RegistrationComponent,
    VerificationCodeComponent,
    ExtLoginRegistrationInfoComponent
}